export default {
    url: '/offers/:offer_id',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Offer data',
        role: 'offers',
    },
    controller: [
        '$scope',
        'offers_api',
        'chartFilters',
        '$stateParams',
        function($scope, offers_api, chartFilters, $stateParams) {
            $scope.data = {};
            $scope.update_offer_data = function(model) {
                offers_api
                    .offer_data({offer_id: $stateParams.offer_id, filters: model})
                    .then(function (resp) {
                        $scope.data = resp;
                    });
            };
            chartFilters.onChangeChartParams('update_offer_data', $scope.update_offer_data);
            $scope.update_offer_data(chartFilters.get_chart_filters());
        },
    ],
};
